import * as React from 'react'
import { SVGProps } from 'react'
const SvgTiktokColored = (props: SVGProps<SVGSVGElement>) => (
  <svg width={13} height={14} viewBox="0 0 13 14" fill="none" {...props}>
    <path
      d="M4.16 7.248c-1.11 0-2.005.896-1.989 1.994.011.704.399 1.316.97 1.657a1.93 1.93 0 0 1-.314-1.03c-.017-1.097.879-1.993 1.988-1.993.218 0 .428.036.625.098V5.776a4.323 4.323 0 0 0-.625-.047h-.03v1.617a2.053 2.053 0 0 0-.626-.098ZM8.953.655h-.585a3.358 3.358 0 0 0 1.27 2.024A3.383 3.383 0 0 1 8.953.655Z"
      fill="#F00044"
    />
    <path
      d="M12.295 4a3.4 3.4 0 0 1-.628-.06v1.576a5.417 5.417 0 0 1-2.141-.434 5.593 5.593 0 0 1-1.218-.71l.01 4.859a4.064 4.064 0 0 1-1.217 2.889 4.143 4.143 0 0 1-2.942 1.204 4.148 4.148 0 0 1-2.548-.863 4.162 4.162 0 0 0 3.206 1.491 4.143 4.143 0 0 0 2.941-1.204 4.065 4.065 0 0 0 1.219-2.89L8.936 5a5.485 5.485 0 0 0 3.36 1.144"
      fill="#F00044"
    />
    <path
      d="M1.868 6.94a4.156 4.156 0 0 1 2.917-1.21v-.582a4.323 4.323 0 0 0-.626-.047c-1.114 0-2.16.43-2.946 1.21A4.092 4.092 0 0 0 0 9.217c0 1.098.434 2.127 1.218 2.906.126.123.254.237.39.341a4.068 4.068 0 0 1-.955-2.619 4.117 4.117 0 0 1 1.215-2.906ZM11.667 3.94v-.584h-.005c-.76 0-1.459-.251-2.021-.677a3.336 3.336 0 0 0 2.026 1.262Z"
      fill="#08FFF9"
    />
    <path
      d="M4.703 11.803c.26.014.508-.022.737-.096a1.968 1.968 0 0 0 1.363-1.865l.003-3.25V.655h1.562a3.402 3.402 0 0 1-.066-.628H6.15v5.935l-.003 3.25c0 .868-.57 1.605-1.362 1.865a2.003 2.003 0 0 1-1.644-.18c.336.518.909.87 1.562.906Z"
      fill="#08FFF9"
    />
    <path
      d="M4.785 13.278A4.143 4.143 0 0 0 7.1 12.12a4.065 4.065 0 0 0 1.218-2.89l-.01-4.858a5.485 5.485 0 0 0 3.36 1.144V3.941a3.336 3.336 0 0 1-2.028-1.262A3.346 3.346 0 0 1 8.37.655H6.805V6.59l-.002 3.25c0 .868-.571 1.605-1.363 1.865-.23.076-.478.112-.737.095a1.992 1.992 0 0 1-1.563-.904 1.965 1.965 0 0 1-.969-1.657c-.016-1.098.88-1.994 1.988-1.994.219 0 .429.036.626.098V5.727a4.156 4.156 0 0 0-2.917 1.21A4.09 4.09 0 0 0 .655 9.84c0 .966.336 1.884.956 2.619.727.56 1.614.863 2.548.863.21.002.42-.014.626-.044Z"
      fill="#000"
    />
  </svg>
)
export default SvgTiktokColored
